import AButton from '@/components/A/AButton/AButton'
import styles from './StepTwo.module.less'
import AIcon from '@/components/A/AIcon/AIcon'
import cls from 'classnames'
// import dayjs from 'dayjs'
import VideoPlayer from '@/pages/ProjectDetailPage/components/VideoAnalysis/VideoPlayer/VideoPlayer'
import { ProjectTypeEnum } from '@/commonConst'
import { api } from '@/api'
import { Link } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import { useEffect, useState } from 'react'
import { message } from 'antd'
import { useAutoRequest } from 'alova/client'
import { useTranslation } from 'react-i18next'
import MiddleText from '@/components/MiddleText/MiddleText'
import {
  GENDER_MAPS,
  INDUSTRY_CATEGORY_MAPS,
  PROJECT_TYPE_MAPS,
  TARGET_MARKTS_MAPS,
} from '@/i18nEnumConsts'
import { i18n } from 'i18next'
import { corpService } from '@/services/corpService'
import { isFreeTrialProductCategory, isPortraitProductCategory } from '@/helpers/productCategory'
import { getIndustryDisplayName } from '@/helpers/industry'

/* const formatTimestamp = (timestamp: number) => {
  return dayjs(timestamp * 1000).format('YYYY-MM-DD HH:mm')
} */

function useEnumI18Lang(
  p: { brandIndustry: string; adCustomerGender: string; adTargetMarket: string },
  i18n: i18n
) {
  const [brandIndustry, setBrandIndustry] = useState<string>(p.brandIndustry)
  const [gender, setGender] = useState<string>(p.adCustomerGender)
  const [targetMarket, setTargetMarket] = useState(p.adTargetMarket)
  useEffect(() => {
    const lng = i18n.language as keyof typeof INDUSTRY_CATEGORY_MAPS
    const industryIngMap = INDUSTRY_CATEGORY_MAPS[lng] as Record<string, string>
    setBrandIndustry(getIndustryDisplayName(p.brandIndustry, industryIngMap))
    const genderMap = GENDER_MAPS[lng] as Record<string, string>
    setGender(genderMap[p.adCustomerGender] || p.adCustomerGender)
    const targetMarketMap = TARGET_MARKTS_MAPS[lng] as Record<string, string>
    setTargetMarket(targetMarketMap[p.adTargetMarket] || p.adTargetMarket)
  }, [i18n.language])
  return { brandIndustry, gender, targetMarket }
}

function StepTwo(props: {
  param?: ProjectModels.CreateProjectParam
  onPrev: () => void
  onSubmit: () => void
  className?: string
  analysisCnt: number
  projectCategory?: ProjectModels.ProjectCategory
}) {
  const { t, i18n } = useTranslation()
  const isPortraitMode = props.projectCategory ? isPortraitProductCategory(props.projectCategory) : false
  const trialStatus = props.projectCategory
    ? corpService.getFreeTrialStatus(props.projectCategory)
    : { freeTrial: false }
  const canUseFreeTrial = props.projectCategory
    ? isFreeTrialProductCategory(props.projectCategory) && trialStatus.freeTrial
    : false
  const [analysisCnt, setAnalysisCnt] = useState(props.analysisCnt)
  const [isInfinite, setIsInfinite] = useState(false)
  const [startPollingCnt, setStartPollingCnt] = useState(true)
  const [confirmed, setConfirmed] = useState(false)

  const { brandIndustry, gender, targetMarket } = useEnumI18Lang(
    {
      brandIndustry: props.param?.brandIndustry || '',
      adCustomerGender: props.param?.adCustomerGender || '',
      adTargetMarket: props.param?.adTargetMarket || '',
    },
    i18n
  )
  const creativeTypeText = props.param?.durationCategory === 'five_to_ten'
    ? t('dashboard.projectCreatePage.durationCategoryOptions.fiveToTen')
    : t('dashboard.projectCreatePage.durationCategoryOptions.tenPlus')
  const onPrevious = () => {
    setConfirmed(false)
    props.onPrev()
  }
  const onConfirm = () => {
    setConfirmed(true)
    if (analysisCnt === 0 && !isInfinite) {
      message.warning(t('dashboard.projectCreatePage.message.insufficientTestPoints'))
      return
    }
    props.onSubmit()
  }

  const handleDoPurchase = () => {
    setStartPollingCnt(true)
  }

  const { data, abort } = useAutoRequest(() => api.corp.analysisCnt({ projectCategory: props.projectCategory }), {
    pollingTime: 2000,
    middleware: (_, next) => {
      if (startPollingCnt) {
        next()
      }
    },
  })

  useEffect(() => {
    setAnalysisCnt(props.analysisCnt)
  }, [props.analysisCnt])

  useEffect(() => {
    if (data?.corpAnalyseCount || data?.isInfinite) {
      setAnalysisCnt(data.corpAnalyseCount)
      setIsInfinite(data.isInfinite)
      if (data?.corpAnalyseCount > 0 || data.isInfinite) {
        setStartPollingCnt(false)
      }
    }
  }, [data])

  useEffect(() => {
    return () => {
      setStartPollingCnt(false)
      abort()
    }
  }, [])

  return (
    props.param && (
      <div className={cls(styles.stepTwo, { [styles.portrait]: isPortraitMode }, props.className)}>
        {isPortraitMode ? (
          <div className={styles.portraitLayout}>
            <div className={styles.portraitPreview}>
              <VideoPlayer url={props.param.adUrl} />
              <div className={styles.badge}>{props.param.brandName}</div>
            </div>
            <div className={styles.portraitRight}>
              <div className={styles.portraitInfoPanel}>
                <div className={styles.portraitInfoList}>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.durationCategory')}: </span>
                    <div className={styles.itemContent}>{creativeTypeText}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.projectName')}: </span>
                    <div className={styles.itemContent}>{props.param.projectName}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.categoryType')}: </span>
                    <div className={styles.itemContent}>{brandIndustry}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.adName')}: </span>
                    <div className={styles.itemContent}>{props.param.adName}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>
                      {t('dashboard.projectCreatePage.targetMarket')}:{' '}
                    </span>
                    <div className={styles.itemContent}>{targetMarket}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>
                      {t('dashboard.projectCreatePage.taGender')}:{' '}
                    </span>
                    <div className={styles.itemContent}>{gender}</div>
                  </div>
                  <div className={styles.portraitInfoItem}>
                    <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.taAge')}: </span>
                    <div className={styles.itemContent}>
                      {t('dashboard.projectDetailPage.infoDrawer.ageRange', {
                        start: props.param.adCustomerAgeStart,
                        end: props.param.adCustomerAgeEnd,
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.costBox}>
                <ul className={styles.costList}>
                  <li className={styles.costItem}>
                    <span>{t('dashboard.projectCreatePage.type')}: </span>
                    <span className={styles.value}>
                      {
                        PROJECT_TYPE_MAPS[i18n.language as keyof typeof PROJECT_TYPE_MAPS][
                        ProjectTypeEnum[
                        props.param.projectType
                        ] as unknown as keyof (typeof PROJECT_TYPE_MAPS)[keyof typeof PROJECT_TYPE_MAPS]
                        ]
                      }
                    </span>
                  </li>
                  <li className={styles.costItem}>
                    <span>{t('dashboard.projectCreatePage.estTime')}: </span>
                    <span className={styles.value}>15 {t('dashboard.projectCreatePage.minutes')}</span>
                  </li>
                </ul>
                <div className={styles.costCntBox}>
                  {
                    canUseFreeTrial
                      ? <div className={cls(styles.costCnt, styles.costCntFreeTrial)}>
                        <span className={styles.label}>{t('dashboard.projectCreatePage.consumption')}: </span>
                        <span className={cls(styles.cnt, styles.freeTrial)}>{t('modals.freeTrialModal.title1')}</span>
                      </div>
                      : <>
                        <div className={styles.costCnt}>
                          <span className={styles.label}>{t('dashboard.projectCreatePage.consumption')}: </span>
                          <span className={styles.cnt}>1</span>
                          <span className={styles.unit}> {t('dashboard.projectCreatePage.testPoint')}</span>
                        </div>
                        {
                          !isInfinite &&
                          <div className={styles.costRemainCntBox}>
                            <span className={cls({ [styles.zero]: analysisCnt === 0 })}>
                              {t('dashboard.projectCreatePage.remaining')}: {analysisCnt}{' '}
                              {t('dashboard.projectCreatePage.times')}
                            </span>
                            {analysisCnt === 0 && (
                              <Link to={PAGE_LINKS.pricing} target='_blank' className={styles.noDecorationLink}>
                                <span className={styles.purchaseBtn} onClick={handleDoPurchase} data-testid='project-create-purchase-btn'>
                                  <span>{t('dashboard.projectCreatePage.purchase')}</span>
                                  <AIcon type='icon-line-global_arrow'></AIcon>
                                </span>
                              </Link>
                            )}
                          </div>
                        }
                        {
                          isInfinite &&
                          <div className={styles.costRemainCntBox}>
                            <span className={styles.infiniteRemain}>
                              {t('dashboard.projectCreatePage.remaining')}: <AIcon type="icon-fill-global_Unlimited2" style={{ fontSize: 18, marginTop: 2 }} />
                            </span>
                          </div>
                        }
                      </>
                  }
                </div>
              </div>
              <div className={styles.btnBox}>
                <AButton testId='project-create-previous-btn' type='outlined' size='LG' onClick={onPrevious}>
                  <MiddleText text={t('dashboard.projectCreatePage.previous')} />
                </AButton>
                <AButton testId='project-create-confirm-btn' type='primary' size='LG' onClick={onConfirm}>
                  <MiddleText text={t('dashboard.projectCreatePage.confirmOrder')} />
                  <AIcon type='icon-line-global_arrow'></AIcon>
                </AButton>
              </div>
              {confirmed && analysisCnt === 0 && !isInfinite ? (
                <p className={cls(styles.bottomMsg, styles.error)}>
                  {t('dashboard.projectCreatePage.message.insufficientTestPoints')}
                </p>
              ) : (
                <>
                  <p className={styles.bottomMsg}>
                    {t('dashboard.projectCreatePage.message.reviewProjectInfo')}
                  </p>
                  <p className={cls(styles.bottomMsg, styles.bottomMsgSub)}>
                    {t('dashboard.projectCreatePage.message.waitingDesc')}
                  </p>
                </>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className={styles.previewBox}>
              <div className={styles.previewCard}>
                <div className={styles.previewCoverBox}>
                  <VideoPlayer url={props.param.adUrl} />
                  <div className={styles.badge}>{props.param.brandName}</div>
                  {/* <img className={styles.previewCover} src={commonUtils.ossVideoToPng(props.param.adUrl)} alt="" /> */}
                </div>
                <div className={styles.previewInfoBox}>
                  <div className={styles.previewTitle}>
                    <span className={styles.titleName}>{props.param.projectName}</span>
                  </div>
                  <p className={styles.previewDesc}>
                    {brandIndustry}｜
                    {
                      PROJECT_TYPE_MAPS[i18n.language as keyof typeof PROJECT_TYPE_MAPS][
                      ProjectTypeEnum[
                      props.param.projectType
                      ] as unknown as keyof (typeof PROJECT_TYPE_MAPS)[keyof typeof PROJECT_TYPE_MAPS]
                      ]
                    }
                  </p>
                </div>
              </div>
              <div className={styles.previewDetail}>
                <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.adName')}: </span>
                  <div className={styles.itemContent}>{props.param.adName}</div>
                </div>
                {/*             <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>Ad Campaign Duration: </span>
                  <div className={styles.itemContent}>
                    {formatTimestamp(props.param.adCampaignDurationStart)} ~
                    {formatTimestamp(props.param.adCampaignDurationEnd)}
                  </div>
                </div> */}
                <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>
                    {t('dashboard.projectCreatePage.targetMarket')}:{' '}
                  </span>
                  <div className={styles.itemContent}>{targetMarket}</div>
                </div>
                {/*             <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>Video Language: </span>
                  <div className={styles.itemContent}>{props.param.adVideoLanguage}</div>
                </div> */}
                <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>
                    {t('dashboard.projectCreatePage.taGender')}:{' '}
                  </span>
                  <div className={styles.itemContent}>{gender}</div>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.itemLabel}>{t('dashboard.projectCreatePage.taAge')}: </span>
                  <div className={styles.itemContent}>
                    {/* {props.param.adCustomerAgeStart} to {props.param.adCustomerAgeEnd} years old */}
                    {t('dashboard.projectDetailPage.infoDrawer.ageRange', {
                      start: props.param.adCustomerAgeStart,
                      end: props.param.adCustomerAgeEnd,
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.costBox}>
              <ul className={styles.costList}>
                <li className={styles.costItem}>
                  <span>{t('dashboard.projectCreatePage.type')}: </span>
                  <span className={styles.value}>
                    {
                      PROJECT_TYPE_MAPS[i18n.language as keyof typeof PROJECT_TYPE_MAPS][
                      ProjectTypeEnum[
                      props.param.projectType
                      ] as unknown as keyof (typeof PROJECT_TYPE_MAPS)[keyof typeof PROJECT_TYPE_MAPS]
                      ]
                    }
                  </span>
                </li>
                <li className={styles.costItem}>
                  <span>{t('dashboard.projectCreatePage.estTime')}: </span>
                  <span className={styles.value}>15 {t('dashboard.projectCreatePage.minutes')}</span>
                </li>
              </ul>
              <div className={styles.costCntBox}>
                {
                  canUseFreeTrial
                    ? <div className={cls(styles.costCnt, styles.costCntFreeTrial)}>
                      <span className={styles.label}>{t('dashboard.projectCreatePage.consumption')}: </span>
                      <span className={cls(styles.cnt, styles.freeTrial)}>{t('modals.freeTrialModal.title1')}</span>
                    </div>
                    : <>
                      <div className={styles.costCnt}>
                        <span className={styles.label}>{t('dashboard.projectCreatePage.consumption')}: </span>
                        <span className={styles.cnt}>1</span>
                        <span className={styles.unit}> {t('dashboard.projectCreatePage.testPoint')}</span>
                      </div>
                      {
                        !isInfinite &&
                        <div className={styles.costRemainCntBox}>
                          <span className={cls({ [styles.zero]: analysisCnt === 0 })}>
                            {t('dashboard.projectCreatePage.remaining')}: {analysisCnt}{' '}
                            {t('dashboard.projectCreatePage.times')}
                          </span>
                          {analysisCnt === 0 && (
                            <Link to={PAGE_LINKS.pricing} target='_blank' className={styles.noDecorationLink}>
                              <span className={styles.purchaseBtn} onClick={handleDoPurchase} data-testid='project-create-purchase-btn'>
                                <span>{t('dashboard.projectCreatePage.purchase')}</span>
                                <AIcon type='icon-line-global_arrow'></AIcon>
                              </span>
                            </Link>
                          )}
                        </div>
                      }
                      {
                        isInfinite &&
                        <div className={styles.costRemainCntBox}>
                          <span className={styles.infiniteRemain}>
                            {t('dashboard.projectCreatePage.remaining')}: <AIcon type="icon-fill-global_Unlimited2" style={{ fontSize: 18, marginTop: 2 }} />
                          </span>
                        </div>
                      }
                    </>
                }
              </div>
            </div>
            <div className={styles.btnBox}>
              <AButton testId='project-create-previous-btn' type='outlined' size='LG' onClick={onPrevious}>
                <MiddleText text={t('dashboard.projectCreatePage.previous')} />
              </AButton>
              <AButton testId='project-create-confirm-btn' type='primary' size='LG' onClick={onConfirm}>
                <MiddleText text={t('dashboard.projectCreatePage.confirmOrder')} />
                <AIcon type='icon-line-global_arrow'></AIcon>
              </AButton>
            </div>
            {confirmed && analysisCnt === 0 && !isInfinite ? (
              <p className={cls(styles.bottomMsg, styles.error)}>
                {t('dashboard.projectCreatePage.message.insufficientTestPoints')}
              </p>
            ) : (
              <>
                <p className={styles.bottomMsg}>
                  {t('dashboard.projectCreatePage.message.reviewProjectInfo')}
                </p>
                <p className={cls(styles.bottomMsg, styles.bottomMsgSub)}>
                  {t('dashboard.projectCreatePage.message.waitingDesc')}
                </p>
              </>
            )}
          </>
        )}
      </div>
    )
  )
}

export default StepTwo
